import React, {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";

import { storage } from "./storage";


const ThemeContext =
  createContext(null);


/* =========================================================
   INITIAL THEME

   RULE:
   - User ne Light explicitly select kiya = Light
   - User ne Dark explicitly select kiya = Dark
   - New user / invalid value = DARK
========================================================= */

function getInitialTheme() {
  const savedTheme =
    storage.get(
      "ck_theme",
      null
    );


  if (
    savedTheme === "light"
  ) {
    return "light";
  }


  if (
    savedTheme === "dark"
  ) {
    return "dark";
  }


  // ✅ DEFAULT FOR EVERY NEW USER
  return "dark";
}


/* =========================================================
   PROVIDER
========================================================= */

export function ThemeProvider({
  children,
}) {

  const [
    theme,
    setThemeState,
  ] =
    useState(
      getInitialTheme
    );


  const [
    fontScale,
    setFontScaleState,
  ] =
    useState(() => {

      const value =
        storage.get(
          "ck_font_size",
          1
        );


      return typeof value ===
        "number"
        ? value
        : 1;
    });


  /* =======================================================
     APPLY THEME
  ======================================================= */

  useEffect(() => {

    const root =
      document.documentElement;


    const isDark =
      theme === "dark";


    /*
     * GurSetu custom
     * CSS theme system.
     */
    root.setAttribute(
      "data-theme",
      isDark
        ? "dark"
        : "light"
    );


    /*
     * Tailwind:
     * dark:* classes
     */
    root.classList.toggle(
      "dark",
      isDark
    );


    /*
     * Native browser /
     * Android controls
     */
    root.style.colorScheme =
      isDark
        ? "dark"
        : "light";


    /*
     * Browser / Android
     * status bar color.
     */
    let metaTheme =
      document.querySelector(
        'meta[name="theme-color"]'
      );


    if (!metaTheme) {

      metaTheme =
        document.createElement(
          "meta"
        );


      metaTheme.name =
        "theme-color";


      document.head.appendChild(
        metaTheme
      );
    }


    metaTheme.setAttribute(
      "content",

      isDark
        ? "#050810"
        : "#FBF6EA"
    );

  }, [theme]);


  /* =======================================================
     FONT SCALE
  ======================================================= */

  useEffect(() => {

    document
      .documentElement
      .style
      .fontSize =
        `${16 * fontScale}px`;

  }, [fontScale]);


  /* =======================================================
     SET THEME

     Only light/dark accepted.
     Anything invalid -> dark.
  ======================================================= */

  const setTheme = (
    nextTheme
  ) => {

    const safeTheme =
      nextTheme === "light"
        ? "light"
        : "dark";


    setThemeState(
      safeTheme
    );


    storage.set(
      "ck_theme",
      safeTheme
    );
  };


  /* =======================================================
     TOGGLE
  ======================================================= */

  const toggleTheme =
    () => {

      setTheme(
        theme === "dark"
          ? "light"
          : "dark"
      );
    };


  /* =======================================================
     FONT SIZE
  ======================================================= */

  const setFontScale =
    (value) => {

      setFontScaleState(
        value
      );


      storage.set(
        "ck_font_size",
        value
      );
    };


  /* =======================================================
     PROVIDER
  ======================================================= */

  return (

    <ThemeContext.Provider
      value={{
        theme,
        setTheme,
        toggleTheme,
        fontScale,
        setFontScale,
      }}
    >

      {children}

    </ThemeContext.Provider>

  );
}


/* =========================================================
   HOOK
========================================================= */

export function useTheme() {

  const ctx =
    useContext(
      ThemeContext
    );


  if (!ctx) {

    throw new Error(
      "useTheme must be used within ThemeProvider"
    );
  }


  return ctx;
}